import React, { useState, useContext, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { fetchImageId } from "../api/apiManagement";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { FormContext } from "./Form";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Box,
  Select,
  MenuItem,
  FormHelperText,
  Checkbox,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { sumCounts } from "../components/sumCounts";

const GamePage = () => {
  const {
    setCurrentStep,
    data,
    setData,
    isLoading,
    setIsLoading,
    imeiChance,
    setImeiChange,
  } = useContext(FormContext);
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    control,
    setError,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "answer",
  });

  const [currentImageId, setCurrentImageId] = useState(0);
  useEffect(() => {
 
    setIsLoading(true);
    fetchImageId()
      .then((res) => {
        const currentStatus = res.data.status;
        if (currentStatus == 200) {
          setCurrentImageId(res.data.data);
        }
   
        setIsLoading(false);
      })
      .catch((err) => {

        setIsLoading(false);
      });
    const totalCount = data.imei.reduce((sum, item) => sum + item.count, 0);

    for (let i = 0; i < totalCount; i++) {
      append({ value: "" });
    }
  }, []);

  const [showMessage, setShowMessage] = useState(false);

  const checkForEmptyValues = (array) => {
    // Use some to check if any object has an empty value
    const hasEmptyValues = array.some((item) => item.value === "");

    if (hasEmptyValues) {
     
      setShowMessage(true);
      return;
    } else {
      setShowMessage(false);
    
      return;
    }
  };

  useEffect(() => {
    checkForEmptyValues(getValues("answer"));

  }, [watch()]);

  const onSubmitGame = (d) => {

    setData({ ...data, answer: d.answer, imgId: currentImageId });
    setCurrentStep(2);
  };
  

  return (
    <Box>
      <Box sx={{ marginBottom: 5 }}>
        {currentImageId == 1 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_1.jpg`} />
          </>
        ) : currentImageId == 2 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_2.jpg`} />
          </>
        ) : currentImageId == 3 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_3.jpg`} />
          </>
        ) : currentImageId == 4 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_4.jpg`} />
          </>
        ) : currentImageId == 5 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_5.jpg`} />
          </>
        ) : currentImageId == 6 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_6.jpg`} />
          </>
        ) : currentImageId == 7 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_7.jpg`} />
          </>
        ) : currentImageId == 8 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_8.jpg`} />
          </>
        ) : currentImageId == 9 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_9.jpg`} />
          </>
        ) : currentImageId == 10 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_10.jpg`} />
          </>
        ) : currentImageId == 11 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_11.jpg`} />
          </>
        ) : currentImageId == 12 ? (
          <>
            <img width={"100%"} src={`assets/img/game_image_12.jpg`} />
          </>
        ) : (
          <></>
        )}
      </Box>{" "}
      <Box sx={{ margin: "20px 0" }}>
        <FormHelperText sx={{ fontSize: "18px", textAlign: "center", marginBottom:"20px" }}>
          <Trans i18nKey="global:game_description" />
        </FormHelperText>
        <FormHelperText sx={{ textAlign: "center", fontSize: "14px" }}>
          <Trans i18nKey="global:game_chance" count={imeiChance} />
        </FormHelperText>
      </Box>
      <Box sx={{ height: "100%" }}>
        {fields.map((item, index) => (
          <Box key={item.id} sx={{ height: 100 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Controller
                name={`answer.${index}.value`}
                control={control}
                render={({ field }) => (
                  <TextField
                    fullWidth
                    label={t("global:question")}
                    {...field}
                    type="number"
                    onInput={(e) => {
                      e.target.value = Math.max(0, parseInt(e.target.value))
                        .toString()
                        .slice(0, 3);
                    }}
                  />
                )}
              />
            </Box>
            {errors?.answer?.[index]?.value && (
              <FormHelperText error>
                <Trans i18nKey="global:question_error" />
              </FormHelperText>
            )}
          </Box>
        ))}
      </Box>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          flexDirection: "column",
        }}
      >
        {showMessage ? (
          <FormHelperText error>
            <Trans i18nKey="global:question_message" />
          </FormHelperText>
        ) : (
          <></>
        )}
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ marginRight: "20px" }}>
            <LoadingButton
              onClick={() => setCurrentStep(0)}
              loading={isLoading}
              variant="outlined"
            >
              <Trans i18nKey="global:back" />
            </LoadingButton>
          </Box>
          <Box sx={{ marginLeft: "20px" }}>
            <LoadingButton
              onClick={handleSubmit(onSubmitGame)}
              loading={isLoading}
              variant="outlined"
            >
              <Trans i18nKey="global:next" />
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default GamePage;
